import Input from './input'

Input.install = vue => {
  vue.component(Input.name, Input)
}

export default Input
